async function postData(url, data) {
    // Default options are marked with *
    const response = await fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
    //   cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    //   credentials: 'include', // include, *same-origin, omit
    
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      //redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
    const mresp = await response.json()
    const res = await mresp.message
   
    return res; // parses JSON response into native JavaScript objects
  }

  export function postMyData(url, data){

    return new Promise(async (resolve, reject)=>{
        try{

            resolve(postData(url, data))

        }catch(e){
            ()=>reject(e)
        }
        

    })
    
    
  }

  async function postDataImage(url, data) {
    // Default options are marked with *
    const expires =10000
    const response = await fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
    //   cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    //   credentials: 'include', // include, *same-origin, omit
   
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': `public, max-age=${expires}, s-maxage=${expires}, stale-while-revalidate=${expires}`,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      //redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
    const mresp = await response.json()
    const res = await mresp.message
   
    return res; // parses JSON response into native JavaScript objects
  }

  export function postMyDataImage(url, data){

    return new Promise(async (resolve, reject)=>{
        try{

            resolve(postDataImage(url, data))

        }catch(e){
            ()=>reject(e)
        }
        

    })
    
    
  }
    
